import Toastify from 'toastify-js'

window.Toastify = Toastify
const showToastify = (message, opts) => {
	Toastify({
		duration: 3000,
		position: "center",
		style: { background: "rgb(86, 18, 129)" },
		text: message,
		...opts
	}).showToast();
}

export default showToastify